import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GraphPreview } from "./render";
import { FaCopy } from "react-icons/fa";

export const Graph = () => {
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Nuevos parámetros
  const [scenarioId, setScenarioId] = useState(queryParams.get("scenarioId") || "defaultScenario");
  const [boUser, setBoUser] = useState(queryParams.get("boUser") || "BoUser");
  const [mainUser, setMainUser] = useState(queryParams.get("mainUser") || "-");
  const [deep, setDeep] = useState(queryParams.get("deep") || "3");
  const [type, setType] = useState(queryParams.get("type") || "A");

  const [environment, setEnvironment] = useState(
    queryParams.get("environment") || "DEV"
  );

  const defaultData = {
    "main": "",
    "nodes": [],
    "edges": []
  };

  const [graphData, setGraphData] = useState(defaultData);
  const [graphDataText, setGraphDataText] = useState(JSON.stringify(defaultData, null, 2));

  const [colorBackground, setColorBackground] = useState(
    queryParams.get("colorBackground") || "#FFFFFF"
  );

  const [colorBorder, setColorBorder] = useState(
    queryParams.get("colorBorder") || "#C4C4C4"
  );

  const [colorMainEdge, setColorMainEdge] = useState(
    queryParams.get("colorMainEdge") || "#000000"
  );

  useEffect(() => {
    console.log("colorMainEdge from URL:", queryParams.get("colorMainEdge"));
    console.log("colorMainEdge state:", colorMainEdge);
  }, [colorMainEdge]);

  // useEffect para cargar datos cuando se proveen los parámetros necesarios
  useEffect(() => {
    const fetchGraphData = async () => {
      setLoading(true);
      try {
        // Construir la URL de la API usando la variable de entorno
        const apiUrl = `${process.env.REACT_APP_BACK_URL}/api/backoffice/relations/${scenarioId}/boUser/${mainUser}/${deep}/${type}`;
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error(`Error fetching graph data: ${response.status}`);
        }

        const data = await response.json();

        setGraphData(data.data);

      } catch (error) {
        console.error("Error fetching graph data:", error);

      } finally {
        setLoading(false);
      }
    };

    fetchGraphData();
  }, [scenarioId, boUser, mainUser, deep]);

  const linkToCopy =
    process.env.REACT_APP_FRONT_URL +
    "/graph?na=1" +
    "&environment=PROD" +
    "&scenarioId=" +
    encodeURIComponent(scenarioId || "") +
    "&boUser=" +
    encodeURIComponent(boUser || "") +
    "&mainUser=" +
    encodeURIComponent(mainUser || "") +
    "&deep=" +
    encodeURIComponent(deep || "") +
    "&colorBackground=" +
    encodeURIComponent(colorBackground) +
    "&colorMainEdge=" +
    encodeURIComponent(colorMainEdge);

  const handleCopy = () => {
    navigator.clipboard.writeText(linkToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div
        className={environment === "PROD" ? "" : "flex flex-col items-center justify-center"}
        style={{
          width: environment === "PROD" ? "100vw" : "100%",
          height: environment === "PROD" ? "100vh" : "auto",
          backgroundColor: colorBackground,
          margin: 0,
          padding: 0,
          overflow: environment === "PROD" ? "hidden" : "visible",
          position: environment === "PROD" ? "fixed" : "relative",
          top: environment === "PROD" ? 0 : "auto",
          left: environment === "PROD" ? 0 : "auto",
        }}
      >
        {environment === "DEV" && (
          <>
            <h1 style={{ fontSize: 40, fontWeight: "bold" }}>
              Graph Component
            </h1>
            <br />
            <br />
            <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
            <br />

            <h3 className="text-md font-semibold mb-3 mt-10">
              Query Parameters (Nuevos)
            </h3>
            <div className="flex flex-wrap items-start justify-start gap-4 w-full">
              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">scenarioId</div>
                  <p className="text-gray-700 text-base flex-grow">
                    ID del escenario
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        value={scenarioId || ""}
                        onChange={(e) => setScenarioId(e.target.value)}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">boUser</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Usuario del BO
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        value={boUser || ""}
                        onChange={(e) => setBoUser(e.target.value)}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">mainUser</div>
                  <p className="text-gray-700 text-base flex-grow">
                    ID del usuario principal (se centrará en el grafo)
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        value={mainUser || ""}
                        onChange={(e) => setMainUser(e.target.value)}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">deep</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Profundidad de las relaciones
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        value={deep || ""}
                        onChange={(e) => setDeep(e.target.value)}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">type</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Type (A=All, C=Clients, E=Empresas)
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        value={type || ""}
                        onChange={(e) => setType(e.target.value)}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorBackground</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color del fondo del html area
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        onChange={(e) => setColorBackground(e.target.value)}
                        value={colorBackground}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorBorder</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color del borde de los nodos y las líneas
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        onChange={(e) => setColorBorder(e.target.value)}
                        value={colorBorder}
                    />
                  </p>
                </div>
              </div>

              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: 400}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorMainEdge</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color del edge principal (default: negro)
                    <br/>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                        onChange={(e) => setColorMainEdge(e.target.value)}
                        value={colorMainEdge}
                    />
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-md font-semibold mb-3 mt-10">
              Data Preview (Solo lectura)
            </h3>
            <div className="flex flex-wrap items-start justify-start gap-4 w-full">
              <div
                  className="h-auto rounded overflow-hidden bg-white"
                  style={{width: "80%"}}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">Graph Data</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Datos del grafo (editable para testing)
                    <br/>
                    <textarea
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700 font-mono text-sm"
                      rows={15}
                      value={graphDataText}
                      onChange={(e) => {
                        setGraphDataText(e.target.value);
                        try {
                          const newData = JSON.parse(e.target.value);
                          setGraphData(newData);
                        } catch (err) {
                          // El JSON no es válido todavía, esperamos a que termine de editar
                        }
                      }}
                    />
                  </p>
                </div>
              </div>

            </div>

            <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>
            <br />
            <br />
          </>
        )}

        <GraphPreview
          graphData={graphData}
          environment={environment}
          colorBackground={
            colorBackground !== undefined && colorBackground !== ""
              ? "#" + colorBackground.replace("#", "")
              : colorBackground
          }
          colorBorder={
            colorBorder !== undefined && colorBorder !== ""
              ? "#" + colorBorder.replace("#", "")
              : colorBorder
          }
          colorMainEdge={
            colorMainEdge !== undefined && colorMainEdge !== ""
              ? "#" + colorMainEdge.replace("#", "")
              : colorMainEdge
          }
        />

        {environment === "DEV" && (
          <div>
            <br />
            <br />
            <h3 className="text-lg font-semibold mb-3">ACTIONS</h3>
            <div className="flex items-center mb-5">
              <button
                onClick={handleCopy}
                className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
              >
                <FaCopy className="mr-2" />
                {copied ? "Copied!" : "Copy Link"}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
